/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import CheckTile from '../CheckTile';
import classes from './Section.module.css';

const Section = props => {
  const {
    section,
    showPopup,
    checkList,
    onFooterButtonPress,
    count,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.sectionHeader}>
        {section?.name} <span className={classes.count}>({count})</span>
      </div>
      <div className={classes.checkTileWrapper}>
        {checkList.map(check =>
          <CheckTile
            key={check.id}
            section={section}
            check={check}
            showPopup={showPopup}
            onFooterButtonPress={onFooterButtonPress}
          />
        )}
      </div>
    </div>
  );
};

export default Section;

Section.propTypes = {
  section: PropTypes.object,
  showPopup: PropTypes.func,
  checkList: PropTypes.array,
  onFooterButtonPress: PropTypes.func,
  count: PropTypes.number,
};

Section.defaultProps = {
  section: {},
  showPopup: () => { },
  checkList: [],
  onFooterButtonPress: () => { },
  count: 0,
};
